export default "__VITE_ASSET__nveq8Qm3__"